import React,{useReducer} from "react";
import axios from 'axios';
import AuthContext from "./authContext";
import authReducer from './authReducer';
import setAuthToken from "../../utils/setAuthToken";

import {
    REGISTER_SUCCESS,
    REGISTER_FAIL,
    USER_LOADED,
    AUTH_ERROR,
    LOGIN_SUCCESS,
    LOGIN_FAIL,
    LOGOUT,
    CLEAR_ERRORS
} from '../types';

const AuthState = props => {

    const initialState ={
        token: localStorage.getItem('token'),
        isAuthenticated: false,
        isClient: false,
        isAdmin: false,
        isSuperAdmin: false,
        loading: true,
        user: null,
        error: null
    }

    const[state,dispatch] = useReducer(authReducer, initialState);

    const loadUser = async () =>{
        //@todo - load token into global headers
        if(localStorage.token){
            setAuthToken(localStorage.token);
        }
        try {
            const res = await axios.get('/api/auth');

            dispatch({
                type:USER_LOADED,
                payload: res.data
            })
        } catch (err) {

            dispatch({
                type:AUTH_ERROR
            })
        }
    }

    const login = async formData =>{
        const config ={
            headers:{
                'Content-Type':'application/json'
            }
        }

        try {
            const res = await axios.post('/api/auth', formData, config);
            dispatch({
                type: LOGIN_SUCCESS,
                payload: res.data
            })
            loadUser();
        } catch (err) {
            console.log(err.response);
            dispatch({
                type: LOGIN_FAIL,
                payload: err.response.data.msg
            })
        }
    }

    const logout = () => dispatch({type:LOGOUT});

    const clearErrors = () => dispatch({type:CLEAR_ERRORS});

     // Register user
     const register = async formData =>{
        const config ={
            headers:{
                'Content-Type':'application/json'
            }
        }

        try {
            const res = await axios.post('/api/users/register', formData, config);
            dispatch({
                type: REGISTER_SUCCESS,
                payload: res.data
            })
            loadUser();
        } catch (err) {
            dispatch({
                type: REGISTER_FAIL,
                payload: err.response.data.msg
            })
        }
    }

    return (
        <AuthContext.Provider value ={{
                token: state.token,
                isAuthenticated: state.isAuthenticated,
                loading: state.loading,
                user: state.user,
                error: state.error,
                isClient: state.isClient,
                isAdmin: state.isAdmin,
                isSuperAdmin: state.isSuperAdmin,
                login,
                logout,
                loadUser,
                clearErrors,
                register
            }}>
            {props.children}
        </AuthContext.Provider>
    )
}

export default AuthState;